import React from 'react';
import {useParams} from 'react-router-dom'
import { products } from '../data/products';
import Breadcrum from '../Components/Breadcrums/Breadcrum';
import ProductDisplay from '../Components/ProductDisplay/ProductDisplay';
import DescriptionBox from '../Components/DescriptionBox/DescriptionBox';
import RelatedProducts from '../Components/RelatedProducts/RelatedProcuts';

const Product = () => {
    const {productId} = useParams();
    const product = products.find((e)=> e.id === Number(productId));

    return (
        <div>
            <Breadcrum product={product}/>
            <ProductDisplay product={product}/>
            <DescriptionBox />
            <RelatedProducts/>
        </div>
    )
}

export default Product
